import { render, staticRenderFns } from "./room-primary.vue?vue&type=template&id=4960c814&scoped=true&"
import script from "./room-primary.vue?vue&type=script&lang=js&"
export * from "./room-primary.vue?vue&type=script&lang=js&"
import style0 from "./room-primary.vue?vue&type=style&index=0&id=4960c814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960c814",
  null
  
)

export default component.exports